import { resolveComponent as _resolveComponent, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_map_popup = _resolveComponent("map-popup")

  return _withDirectives((_openBlock(), _createBlock(_component_map_popup, {
    lang: $props.lang,
    "is-admin": $props.isAdmin
  }, null, 8, ["lang", "is-admin"])), [
    [_vShow, _ctx.map!=null]
  ])
}